import { Component } from 'react';

class AIMS extends Component {
  render() {
    return <h1>AIMS</h1>;
  }
}

export default AIMS;
